import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setCurrentParrentalCodeAccount, setParentalCodeStep, saveToHistory} from '../../Block/TvActivationCodeRecoveryBlock/TvActivationCodeRecoveryBlockSlice';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import ErrorPage from './EmptyTvItem';
import {redirectToLogin} from '../ChangePricePlanBlock/changePricePlanSlice';
import VerifyTVInfo from './VerifyTVInfo';
import {Step} from '../TvResetParentalCodeBlock/ResetParentalCodeEnum';
import {parentalControlReport} from './ParentalControlReports';
import {gtag4} from '../../../utilities/analytics/tracking';
//import ResetCode from "app/Components/Block/TvResetParentalCodeBlock/ResetCode";

const TvCustomerList = (props) => {

    const [active, setActive] = useState(null);
    const customersAmount = props.customerList?.length;
    const [account, setAccount] = useState(null);
    const [errorMsg, setErrorMsg] = useState(false);
    const errorMsgChooseAccount = 'אנא בחר מנוי';

    useEffect(() => {
        props.saveToHistory('tv-list');
    }, []);

    useEffect(() => {
        if (props.tvAccounts != null) {
            setAccount(props.tvAccounts);
        }

        if (props.customerList?.length > 1) {
            let userDetails = props.authentication?.loginData?.userDetails;
            parentalControlReport('Select Subscription Page', 'Ongoing', 'Select Subscription Page Displayed', '', userDetails.firstName
                + ' ' + userDetails.lastName, userDetails?.IDNumber, '', '');
        }

    }, [props.tvAccounts, props.customerList?.length]);


    useEffect(() => {
        if (active != null) {
            setErrorMsg(false);
        }

    }, [active]);

    useEffect(() => {
        if (customersAmount === 1 && props.getCustomerStatus) {
            props.setCurrentParrentalCodeAccount(props.customerList[0]);
            props.setParentalCodeStep(Step.RESET_CODE);
        }
    }, [customersAmount, props.getCustomerStatus, props.customerList]);

    const gaOnClick = () => {
        gtag4({
            event: 'ParentalControlCode_Step1_ContinueClickButton',
            button: "המשך",
            step: '1',
            action: 'ContinueClickButton'
        }) //Google analytic
    }

    const handleClick = () => {
        if (active != null) {
            props.setCurrentParrentalCodeAccount(props.customerList[active]);
            let userDetails = props.authentication?.loginData?.userDetails;
            parentalControlReport('Select Subscription Page', 'Ongoing', 'Subscription Page Button Clicked', props.customerList[active].username, userDetails.firstName + ' ' + userDetails.lastName, userDetails?.IDNumber, '', '', '', props.customerList[active]?.ban);
            //props.setParentalCodeStep(Step.VERIFY_ACCOUNT);
            //props.getPinParentalCodeAsync();
            props.setParentalCodeStep(Step.RESET_CODE);
            setErrorMsg(false);
            gaOnClick();
        } else if (active == null) {
            setErrorMsg(true);
        }
    }

    if (customersAmount == 0 && props.getCustomerStatus && props.authentication?.loginData?.isFullAuthenticated) {
        return (
            <ErrorPage
                title={`מצטערים, אנחנו לא מזהים שיש לכם שירות ${window.Config.brand_Name_HE} TV`}
                subTitle={'יכול להיות שנרשמתם עם פרטים אחרים? שווה לנסות להתחבר שוב'}
                linkInfo={'לחצו כאן להצטרפות לשירות'}
                backToLobby={'חזרה לאיזור האישי'}
                cellTvPage={props.cellTvPage}
                context={props.context}
                userData={props.authentication?.loginData?.userDetails}
            />
        );
    } else {
        if (customersAmount == 1 && props.getCustomerStatus) {
            return null;
        } else if (customersAmount > 1 && props.getCustomerStatus) {
            const title1 = 'איזה כיף!';
            const title2 = `יש לכם כמה מנויי ${window.Config.brand_Name_HE} TV`;
            const title3 = 'באיזה מנוי תרצו לבצע את הפעולה?';

            let arr = props.customerList;
            return (
                <div className='tv-customer-list'>
                    <div className='title-info-big-1'>{title1}</div>
                    <div className='title-info-big-2'>{title2}</div>
                    <div className='title-info-small'>{title3}</div>


                    {arr?.map((item, index) => {
                        return (
                            <div
                                className='customer-info'
                                key={index}
                                role='button'
                                tabIndex={index}
                                onClick={() => {
                                    setActive(index)
                                }}>
                                <div className='customer-info-content'>
                                    <div className={`${active == index ? 'active' : ''} info`}>
                                        <Image src={active == index ? require('./images/radio-fill.svg') :
                                            require('./images/radio-empty.svg')} />
                                        <div className='info-details'>
                                            <div className='info-title'>מנוי {window.Config.brand_Name_HE} TV</div>
                                            <div className='email'>{item.username}</div>
                                            <div className='address'>{item.address}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    {errorMsg && <div className='error-msg-choose-account'>{errorMsgChooseAccount}</div>}

                    <div style={{marginTop: errorMsg ? '-15px' : ''}}>
                        <BtnSubmit
                            text={'המשך'}
                            onclick={handleClick}
                        />
                    </div>
                </div>
            );
        } else return <></>
    }
};

const mapStateToProps = (state) => {
    return {
        getCustomerStatus: state.TvActivationCodeRecovery?.getCustomersReady,
        authentication: state.authentication,
        tvAccounts: state.TvActivationCodeRecovery.currentParrentalCodeAccount,

    };
};

const mapDispatchToProps = {
    redirectToLogin,
    setCurrentParrentalCodeAccount,
    setParentalCodeStep,
    saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(TvCustomerList);
